export const getHelp =
  (id: number) => async (dispatch: Function, _getState: Function, api: any) => {
    try {
      return await api.get(`help/${id}`);
    } catch (err) {
      console.error(err);
      return [];
    }
  };
